import { GET_MEETING_ROOM_APPROVAL_DETAILS_ACTION_TYPE, GET_MEETING_ROOM_APPROVAL_LIST_ACTION_TYPE, GET_MEETING_ROOM_APPROVAL_EXPORT_DATA_ACTION_TYPE, UPDATE_MEETING_ROOM_APPROVAL__ACTION_TYPE } from "../../../../utils/constants";


const initialState = [];

function meetingRoomApprovalReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_MEETING_ROOM_APPROVAL_DETAILS_ACTION_TYPE:
            return [...state, payload];
        case GET_MEETING_ROOM_APPROVAL_LIST_ACTION_TYPE:
            return [...state, payload];
        case GET_MEETING_ROOM_APPROVAL_EXPORT_DATA_ACTION_TYPE:
            return [...state, payload];
        case UPDATE_MEETING_ROOM_APPROVAL__ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default meetingRoomApprovalReducer;